import { Image } from '@mantine/core'
import React from 'react'

import { DisplayAssetProps } from '../../../types/preview'

const DisplayImage = ({
  asset,
  height,
  openInModal,
  modalOpen,
}: DisplayAssetProps): React.ReactElement => {
  return (
    <Image
      onClick={() => openInModal()}
      src={asset.public_url ?? asset.data}
      fit={modalOpen ? 'contain' : 'cover'}
      height={modalOpen ? '90vh' : height}
      style={{ cursor: 'pointer' }}
    />
  )
}

export default DisplayImage
